import React from 'react';
const costData = [{
  sin: 'Domingos buscando recetas que no funcionan',
  costo: 'Horas de tu vida que no recuperás nunca'
}, {
  sin: 'Ingredientes caros que terminan en la basura',
  costo: 'Plata perdida en cada intento fallido'
}, {
  sin: 'Sin recetas organizadas por categoría',
  costo: 'Buscás en Google y nunca encontrás lo que necesitás'
}, {
  sin: 'Sin sistema de porciones claro',
  costo: 'Seguís comiendo con miedo constante a la glucosa'
}, {
  sin: 'Sin técnica correcta de masas',
  costo: 'El pan sigue quedando seco y sin sabor'
}, {
  sin: 'Sin método paso a paso probado',
  costo: 'Te rendís antes de empezar una y otra vez'
}];
export function CostOfNotHaving() {
  return <section className="py-20 px-4 bg-brand-jet border-t border-brand-gold/15 relative overflow-hidden" data-id="element-73">
      <div className="absolute inset-0 grain pointer-events-none" data-id="element-74"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-75">
        <div className="mb-10 text-center" data-id="element-76">
          <h2 className="font-display text-3xl sm:text-4xl font-extrabold text-brand-gold flex items-center justify-center gap-3 glow-gold tracking-tight" data-id="element-77">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
        </div>

        <div className="rounded-2xl overflow-hidden mb-12 border border-brand-gold/30 bg-brand-base/70 backdrop-blur-sm" data-id="element-78">
          <div className="overflow-x-auto" data-id="element-79">
            <table className="w-full text-left border-collapse" data-id="element-80">
              <thead data-id="element-81">
                <tr className="bg-brand-gold/15 border-b border-brand-gold/30" data-id="element-82">
                  <th className="p-5 font-extrabold w-1/2 text-base text-center text-brand-gold tracking-wide uppercase" data-id="element-83">
                    ❌ Sin Megapack
                  </th>
                  <th className="p-5 font-extrabold w-1/2 text-base text-center text-brand-gold tracking-wide uppercase border-l border-brand-gold/20" data-id="element-84">
                    💸 Costo Real
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-85">
                {costData.map((row, i) => <tr key={i} className="border-b border-brand-gold/15 last:border-b-0" data-id="element-86">
                    <td className="p-5 text-brand-cream/85 font-medium text-center text-sm sm:text-base" data-id="element-87">
                      {row.sin}
                    </td>
                    <td className="p-5 text-brand-gold font-bold border-l border-brand-gold/15 text-center text-sm sm:text-base" data-id="element-88">
                      {row.costo}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <p className="font-display text-xl sm:text-3xl font-bold text-brand-cream tracking-tight leading-snug text-center max-w-3xl mx-auto" data-id="element-89">
          El próximo domingo podés estar sacando pan del horno con toda la
          familia
          <br className="hidden sm:block" data-id="element-90" /> — o buscando otra receta que
          tampoco va a funcionar.
        </p>
      </div>
    </section>;
}